import { inject, Injectable, NgZone } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

// Servicios
import { HttpService } from './http.service';

import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ChangePassIniCommand, User } from '../class/user.class';
import { SessionStorageService } from './sessionl-storage.service';
import { ENV_TOKEN } from '../../app-module.token';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  private httpService: HttpService = inject(HttpService);
  private zone: NgZone = inject(NgZone);
  private router: Router = inject(Router);
  readonly environment = inject(ENV_TOKEN);
  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }



  login(request: any): Observable<any> {
    const funcion = "icoij/authenticationSafe";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  changeInitialPassword(request: ChangePassIniCommand): Observable<any> {
    const funcion = "icoij/ChangeInitialPass";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  getOrganosOIJ(idTipoOrg: number, idOrgAux: number): Observable<any> {
    const funcion = "icoij/getCourtsIJ";
    const ruta = `${this.urlRaiz}/${funcion}/${idTipoOrg}/${idOrgAux}`;
    return this.httpService.getRequest(ruta);
  }
  getPagOrganosOIJ(idTipoOrg: number, idOrgAux: number): Observable<any> {
    const funcion = "icoij/GetPagingManagement";
    const ruta = `${this.urlRaiz}/${funcion}/${idTipoOrg}/${idOrgAux}`;
    return this.httpService.getRequest(ruta);
  }
   getOrganosOIJPaging(idTipoOrg: number, idOrgAux: number,page:number,records:number): Observable<any> {
    const funcion = "icoij/ObtenerOIJPaging";
    const ruta = `${this.urlRaiz}/${funcion}/${idTipoOrg}/${page}/${records}/${idOrgAux}`;
    return this.httpService.getRequest(ruta);
  }

  getTipoOrganismo(): number {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.idTypeCourt;
    else return 0;
  }

  getIdTypeCourt(): number {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.idTypeCourt;
    else return 0;
  }

  logout(): void {
    this.sessionStorageService.removeItem('currentUser');
    this.zone.run(() => {
      this.router.navigateByUrl('/login');
    });
  }

  getUserName(): string {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser !== null)
      return currentUser.userName;
    else return '';
  }

  getNameCourt(): string {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser !== null)
      return currentUser.nameCourt;
    else return '';
  }

  getIdUser(): number {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser !== null)
      return currentUser.id;
    else return 0;
  }

  getIdOrgan(): number {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser !== null)
      return currentUser.court;
    else return 0;
  }

  getToken(): string {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser !== null)
      return currentUser.token;
    else return '';
  }

  getNombreTipoOrganismo(): string {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.TypeCourt;
    else return '';
  }

  getIdOrganoAux(): number {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.courtAux;
    else return 0;
  }
  getOrganoAux(): string {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.nameCourtAux;
    else return '';
  }

  getIsAdmin(): boolean {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.isAdmin;
    else return false;
  }

  getIdAdmin(): number {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.idAdmin;
    else return 0;
  }

  getOrganosAutorizados(): number {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.OrganosAutorizados;
    else return 0;
  }

  getbPermisoAdmin() {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.bPermisoAdmin;
    else return false;
  }

  getbSuperAdmin() {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.bSuperAdmin;
    else return false;
  }

  getbPermisoNoFirma() {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.bPermisoNoFirma;
    else return false;
  }

  getValidSessionCurrentUser(): boolean {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return true;
    else return false;
  }

  getClasificacionOrg() {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.iClasificacionOrganismo;
    else return 0;
  }

  getIdAutoEnrolamiento(): number {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.idAutoEnrolamiento;
    else return 0;
  }

    getOrganosSupervision(idTipoOrg: number, idOrgAux: number): Observable<any> {
    const funcion = "icoij/getCourtsSuper";
    const ruta = `${this.urlRaiz}/${funcion}/${idTipoOrg}/${idOrgAux}`;
    return this.httpService.getRequest(ruta);
  }

    getEsOrganoSupervisado(): boolean {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser != null)
      return currentUser.bajoSupervision;
    else return false;
  }

    getPagOrganosOIJSup(idTipoOrg: number, idOrgAux: number): Observable<any> {
    const funcion = "icoij/GetPagingManagementSup";
    const ruta = `${this.urlRaiz}/${funcion}/${idTipoOrg}/${idOrgAux}`;
    return this.httpService.getRequest(ruta);
  }
   getOrganosOIJPagingSup(idTipoOrg: number, idOrgAux: number,page:number,records:number): Observable<any> {
    const funcion = "icoij/ObtenerOIJPagingSup";
    const ruta = `${this.urlRaiz}/${funcion}/${idTipoOrg}/${page}/${records}/${idOrgAux}`;
    return this.httpService.getRequest(ruta);
  }

}
